import { render, staticRenderFns } from "./RoundList.vue?vue&type=template&id=612ac3f6&"
import script from "./RoundList.vue?vue&type=script&lang=js&"
export * from "./RoundList.vue?vue&type=script&lang=js&"
import style0 from "./RoundList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports